import React, {Component} from 'react'
import './MovieRecordContainer.css'
import HighlightKeywordCell from '../../FunctionArea/HighlightKeywordCell'
import {server_ip} from '../../../ipAddress'


class MovieRecordContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            movieSysID:null,
            movieMainInfo:null,
            movieStaff:null,
            movieActor:null,
            movieUnit:null,
            detailInfoSectionToggle:false,
            actorSectionToggle:false,
            staffSectionToggle:false,
            unitSectionToggle:false
        }
    }

    componentDidMount(){  
        this.initialMovieSysID()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.movieSysID !== this.state.movieSysID)
        {
            this.refreshMovieInfo()
        }
    }

    componentWillUnmount(){
    }

    initialMovieSysID=()=>{
        if(this.props.movieSysID && this.props.movieSysID !== this.state.movieSysID)
        {
            this.setState({
                movieSysID:this.props.movieSysID
            })
        }
    }

    refreshMovieInfo=()=>{
        this.getMovieMainInfo()
        this.getMovieStaff()
        this.getMovieActor()
    }

    getMovieMainInfo=async()=>{
        if(this.state.movieSysID)
        {
            let msg = await fetch(server_ip+'/api/movie/fetch/MovieMainInfo/'+this.state.movieSysID)
            let output = await msg.json()
            console.log("getMovieMainInfo")
            console.log(output[0])
            if(output[0])
            {
                this.setState({
                    movieMainInfo:output[0]
                })
            }
        }
    }

    getMovieStaff=async()=>{
        if(this.state.movieSysID)
        {
            let msg = await fetch(server_ip+'/api/movie/fetch/MovieStaffList/'+this.state.movieSysID)
            let output = await msg.json()
            console.log("getMovieStaff")
            console.log(output)
            if(output[0])
            {
                this.setState({
                    movieStaff:output
                })
            }
        }
    }

    getMovieActor=async()=>{
        if(this.state.movieSysID)
        {
            let msg = await fetch(server_ip+'/api/movie/fetch/MovieActorList/'+this.state.movieSysID)
            let output = await msg.json()
            console.log("getMovieActor")
            console.log(output)
            if(output[0])
            {
                this.setState({
                    movieActor:output
                })
            }
        }
    }
  
    getEncodeFormBody=(formObject)=>{
        let formBody =[]
        for (let property in formObject) 
        {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(formObject[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        return formBody
    }

    getMovieMainInfoSection=()=>{
        if(this.state.movieMainInfo)
        {
            return(   
                <div>      
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>電影名稱</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_TitleMain} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>電影識別號</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_SysID} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRowTwice"}>
                            <div className={"MovieRecordContainerCellTitle"}>劇情大綱</div>
                            <div className={"MovieRecordContainerCellFourXField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_DramaContent} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                </div>
            )
        }
        else
        {
            return null
        }
    }

    createMovieDetailInfoSection=()=>{
        if(this.state.movieMainInfo)
        {
            return(   
                <div>      
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>出品年代</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_ProductionDate} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>出品人</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_Producer} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"expandSectionButton"} onClick={()=>this.setState({detailInfoSectionToggle:!this.state.detailInfoSectionToggle})}>
                            {this.state.detailInfoSectionToggle?"-":"+"}
                        </div>
                    </div>
                    {this.state.detailInfoSectionToggle?
                    <div>
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>出品公司</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_ProductionCompany} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>出品地點</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_ProductionLocation} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>翻譯片名</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_TitleTranslation} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>其他片名</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_TitleOther} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>長片短段</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_SubCategoryOne} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>種類</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_SubCategoryTwo} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>分級</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_Rating} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>語言</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieMainInfo.Movie_Language} keywords={this.props.keywords}/></div>
                        </div>
                    </div>
                    </div>
                    :null
                    }
                </div>
            )
        }
        else
        {
            return null
        }
    }

    createMovieStaffInfoSection=()=>{
        if(this.state.movieStaff)
        {
            return (
            <div className={this.state.staffSectionToggle?"MovieRecordStaffSection":"MovieRecordStaffSectionNotExpand"}>
                <div className={"MovieRecordContainerCell"}>
                    <div className={"MovieRecordContainerCellRow"}>
                        <div className={"MovieRecordContainerCellTitle"}>{this.state.movieStaff[0].Movie_Position}</div>
                        <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieStaff[0].Movie_StaffName?this.state.movieStaff[0].Movie_StaffName:this.state.movieStaff[0].Movie_Company} keywords={this.props.keywords}/></div>
                    </div>
                    <div className={"expandSectionButton"} onClick={()=>this.setState({staffSectionToggle:!this.state.staffSectionToggle})}>
                        {this.state.staffSectionToggle?"-":"+"}
                    </div>
                </div>
                {this.state.staffSectionToggle?this.getStaffList():null}
            </div>)
        }
        else
        {
            return null
        }
    }

    getStaffList=()=>{
        let result = this.state.movieStaff.map((row,index)=>{
            if(row.Movie_StaffName || row.Movie_Company)
            {
                if(index !==0)
                {  
                    return( 
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>{row.Movie_Position}</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={row.Movie_StaffName?row.Movie_StaffName:row.Movie_Company} keywords={this.props.keywords}/></div>
                        </div>  
                    </div>
                    )
                }
                else
                {
                    return null
                }
            }
            else
            {
                return null
            }
        })
        return result
    }

    createMovieActorInfoSection=()=>{
        if(this.state.movieActor && this.state.movieActor[0].Movie_ActorName)
        {
            return (
            <div className={this.state.actorSectionToggle?"MovieRecordStaffSection":"MovieRecordStaffSectionNotExpand"}>
                <div className={"MovieRecordContainerCell"}>
                    <div className={"MovieRecordContainerCellRow"}>
                        <div className={"MovieRecordContainerCellTitle"}>演員</div>
                        <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieActor[0].Movie_ActorName} keywords={this.props.keywords}/></div>
                    </div>
                    {this.state.movieActor[0].Movie_RoleName?
                    <div className={"MovieRecordContainerCellRow"}>
                        <div className={"MovieRecordContainerCellTitle"}>飾演</div>
                        <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.movieActor[0].Movie_RoleName} keywords={this.props.keywords}/></div>
                    </div>
                    :null
                    }
                    <div className={"expandSectionButton"} onClick={()=>this.setState({actorSectionToggle:!this.state.actorSectionToggle})}>
                        {this.state.actorSectionToggle?"-":"+"}
                    </div>
                </div>
                {this.state.actorSectionToggle?this.getActorList():null}
            </div>)
        }
        else
        {
            return null
        }

    }

    getActorList=()=>{
        let result = this.state.movieActor.map((row,index)=>{
            if(row.Movie_ActorName)
            {
                if(index !==0)
                {  
                    return( 
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>演員</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={row.Movie_ActorName} keywords={this.props.keywords}/></div>
                        </div>
                        {row.Movie_RoleName?
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>飾演</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={row.Movie_RoleName} keywords={this.props.keywords}/></div>
                        </div>
                        :null
                        }
                       
                    </div>
                    )
                }
                else
                {
                    return null
                }
            }
            else
            {
                return null
            }
        })
        return result
    }

    render(){
        let recordContainerStyle = {
            width:'100%',
            height:'100%',
            position:'absolute',
            backgroundColor:"#ffffff80",
            zIndex:"2000",   
        }

        let innerContainerStyle = {
            width:'90%',
            maxHeight:"700px",
            position:'relative',
            backgroundColor:"white",
            border:"1px solid black",
            margin:"auto",
            overflowY:"scroll",
            top:"50px",
            borderRadius:"5px",
            boxShadow:"0px 0px 10px 0px black"          
        }


        return(
            <div style={recordContainerStyle}>   
                <div style={innerContainerStyle}>
                    <div className ={"rightTopBoxArea"}>
                        <div className = {"rightTopBox"} onClick={()=>this.props.closeModal()}>{"X"}</div>             
                    </div>
                    {this.getMovieMainInfoSection()}
                    {this.createMovieDetailInfoSection()}
                    {this.createMovieStaffInfoSection()}
                    {this.createMovieActorInfoSection()}
                </div>         
            </div>
        )
    }
}

export default MovieRecordContainer